/*
 * WhatsApp launcher widget — Zellaforte
 * Toggles a small chat panel and opens a wa.me conversation.
 * No dependencies; mirrors the custom-element pattern used in share.js.
 */
if (!customElements.get('whatsapp-widget')) {
  customElements.define(
    'whatsapp-widget',
    class WhatsappWidget extends HTMLElement {
      constructor() {
        super();
        this.launcher = this.querySelector('.zf-wa__launcher');
        this.panel = this.querySelector('.zf-wa__panel');
        this.closeButton = this.querySelector('.zf-wa__close');
        this.cta = this.querySelector('[data-zf-wa-cta]');

        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
      }

      connectedCallback() {
        if (!this.launcher || !this.panel) return;
        this.launcher.addEventListener('click', () => this.toggle());
        if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      toggle() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.panel.hidden = false;
        // Force a frame so the opening transition runs.
        requestAnimationFrame(() => this.classList.add('is-open'));
        this.launcher.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick);
        if (this.cta) this.cta.focus({ preventScroll: true });
      }

      close() {
        if (!this.isOpen && this.panel.hidden) return;
        this.classList.remove('is-open');
        this.launcher.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);

        const hidePanel = () => {
          if (!this.isOpen) this.panel.hidden = true;
        };
        this.panel.addEventListener('transitionend', hidePanel, { once: true });
        // Fallback in case the transition is skipped (reduced motion, etc.).
        setTimeout(hidePanel, 250);

        this.launcher.focus({ preventScroll: true });
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
      }

      onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) this.close();
      }
    }
  );
}
